// Google Sheets integration via Google Apps Script
//
// APPS SCRIPT CODE (paste in Extensions → Apps Script):
//
//    function doPost(e) {
//      var sheet = SpreadsheetApp.getActiveSpreadsheet().getActiveSheet();
//      var data = JSON.parse(e.postData.contents);
//      sheet.appendRow([new Date(), data.email, data.name || '']);
//      return ContentService.createTextOutput(JSON.stringify({ status: 'success' }))
//        .setMimeType(ContentService.MimeType.JSON);
//    }
//

const GOOGLE_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbwEDs5tSXAOxm-2DEoXdWu9wcdjDzvjfxQ3Ozr_s4G_QMocvKXuOxxhVIopWU7LzJHKDg/exec'

export async function submitToNewsletter(
  email: string,
  name?: string,
): Promise<boolean> {
  if (!GOOGLE_SCRIPT_URL) {
    const subject = encodeURIComponent('New Newsletter Signup')
    const body = encodeURIComponent(
      `New signup:\nEmail: ${email}\nName: ${name || 'Not provided'}\nDate: ${new Date().toISOString()}`,
    )
    window.open(
      `mailto:jess@arrivetherapy.ca?subject=${subject}&body=${body}`,
      '_blank',
    )
    return true
  }

  try {
    // Use text/plain to avoid CORS preflight, and no-cors mode
    // Google Apps Script still receives the JSON string in e.postData.contents
    const payload = JSON.stringify({ email, name: name || '' })

    await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain;charset=utf-8',
      },
      body: payload,
    })

    // With no-cors we can't read the response, but the request goes through
    return true
  } catch (error) {
    console.error('Newsletter submission error:', error)
    return false
  }
}
